import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { CancelOrderReasonsFilterEntity } from '../../domain/entities/CancelOrderReasonsFilterEntity'

export class CancelOrderReasonsFilterModel extends CancelOrderReasonsFilterEntity {
  constructor(dataDto: CancelOrderReasonsFilterEntity) {
    super()
    mapEntityProperties<CancelOrderReasonsFilterModel>(this, dataDto)
  }
}
